import * as React from 'react';
import { Button } from "primereact/button";
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { InputText } from 'primereact/inputtext';
import { ActiveIngredientAdminModel } from "../../../models/activeIngredient";
import { InputTextarea } from 'primereact/inputtextarea';
import { ImageModel } from '../../../models';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as Constants from '../../../common/constants';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import AtcCodeService from '../../../services/atcCodeService';
import Spinner from '../../../common/components/spinner/spinner';
import { ATCCodeModel } from '../../../models/atcCode';

interface IProps {
  handleChange: any,
  activeIngredient: ActiveIngredientAdminModel,
  uploadImageClick: any,
  removeImageClick: any,
  toggleImageClick: any,
  setIsVisibleATCCodeListDialog: any,
  removeATCCodeClick: any,
  handleContentChange: any,
  getContentValue: any
}

interface IState {
  isLoading: boolean,
  validationMessage: string
}

class ActiveIngredientTabBasicInfo extends React.Component<IProps, IState> {
  currentImage: ImageModel;
  refImageFile: any;
  atcCodeService = new AtcCodeService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      validationMessage: ''
    };
  }

  componentDidMount() {
    let a = 1;
  }


  isValidAddEditForm() {
    let message = '';

    this.setState({
      validationMessage: ''
    });

    if ((!this.props.activeIngredient.activeIngredientName || this.props.activeIngredient.activeIngredientName.trim() == '')) {
      message += "Please enter 'Name'.<br />";
    }

    this.setState({
      validationMessage: message
    });

    return message == '';
  }

  handleOnChange(event) {
    let file: File = event.target.files[0];
    let message = '';
    let fileExtension = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();

    this.currentImage = new ImageModel();

    if (!fileExtension.match(/(png|jpg|jpeg)$/i)) {
      message += 'Allowed file types are (png, jpg, jpeg).<br />';
    }

    if (file.size > Constants.MaxFileUploadSize) {
      message += 'File size is greater than ' + HelperFunctions.formatBytes(Constants.MaxFileUploadSize, 3) + '.<br />';
    }

    this.setState({
      validationMessage: message
    });

    if (!message) {
      this.currentImage.imageName = file.name;
      this.currentImage.imageType = fileExtension

      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.currentImage.imageContent = reader.result;
        this.props.uploadImageClick(this.currentImage);
      }, false);

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }

  handleATCCodeAddEditClick() {
    this.props.setIsVisibleATCCodeListDialog(true);
  }

  handleATCCodeRemoveClick() {
    this.props.removeATCCodeClick();
  }

  getTitle = (atcCode: ATCCodeModel) => {
    return atcCode.atcCodeContent && atcCode.atcCodeContent.length > 0 ? atcCode.atcCodeContent.map(r => r.atcCodeName).join(' / ') : null
  }

  public render() {

    const { activeIngredient, } = this.props;
    const { isLoading } = this.state;
    const currentActiveImage = activeIngredient.image ? activeIngredient.image : null;
    let imagesArray = new Array<ImageModel>(0);
    if (currentActiveImage) {
      imagesArray.push(currentActiveImage);
    }

    const atcCodeValue = (activeIngredient.atcCode && activeIngredient.atcCode.atcCode)
      ? activeIngredient.atcCode.atcCode + " / " + this.getTitle(activeIngredient.atcCode)
      : "Select ATC Code";

    return (
      <div style={{ minHeight: '550px', maxHeight: '650px' }}>
        {isLoading ? <Spinner /> : null}
        {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
        <div className="p-grid p-md-12">
          <div className="p-col-12 p-md-6">
            <label>Name:</label>
            <InputText
              name="activeIngredientName"
              onChange={(e) => this.props.handleChange('activeIngredientName', e.target['value'])}
              value={activeIngredient && activeIngredient.activeIngredientName ? activeIngredient.activeIngredientName : ""}
            />
          </div>
          <div className="p-col-12 p-md-6">
            <label>Generic INN Name:</label>
            <InputText
              name="genericINNName"
              onChange={(e) => this.props.handleChange('genericINNName', e.target['value'])}
              value={activeIngredient && activeIngredient.genericINNName ? activeIngredient.genericINNName : ""}
            />
          </div>
          <div className="p-col-12 p-md-6">
            <label>Common Chemical Name:</label>
            <InputText
              name="commonChemicalName"
              onChange={(e) => this.props.handleChange('commonChemicalName', e.target['value'])}
              value={activeIngredient && activeIngredient.commonChemicalName ? activeIngredient.commonChemicalName : ""}
            />
          </div>
          <div className="p-col-12 p-md-6">
            <label>Мolecular Formula:</label>
            <InputText
              name="molecularFormula"
              onChange={(e) => this.props.handleChange('molecularFormula', e.target['value'])}
              value={activeIngredient && activeIngredient.molecularFormula ? activeIngredient.molecularFormula : ""}
            />
          </div>
          <div className="p-col-12 p-md-12">
            <label>ATC Code:</label>
            <div className="p-inputgroup">
              <InputText
                value={atcCodeValue}
                readOnly={true}
                onClick={() => this.handleATCCodeAddEditClick()}
              />
              <Button
                icon="pi pi-plus"
                className="p-button-success"
                onClick={() => this.handleATCCodeAddEditClick()}
              />
              <Button
                icon="pi pi-times-circle"
                className="p-button-warning"
                onClick={() => this.handleATCCodeRemoveClick()}
              />
            </div>
          </div>
          <div className="p-col-12 p-md-6">
            <label>IUPAC Chemical Name:</label>
            <InputTextarea
              name="iupacChemicalName"
              style={{ width: '100%' }}
              rows={5}
              onChange={(e) => this.props.handleChange('iupacChemicalName', e.target['value'])}
              value={activeIngredient && activeIngredient.iupacChemicalName ? activeIngredient.iupacChemicalName : ""}
            />
          </div>
          <div className="p-col-12 p-md-6">
            <label>Image:</label>
            <div className="p-grid p-md-12">
              <input type="file" onChange={(e) => this.handleOnChange(e)} style={{ display: 'none' }} ref={(el) => this.refImageFile = el} />
              <Button
                type="button"
                label={imagesArray.length > 0 ? "Update" : "Add New"}
                className="p-button-success"
                tooltip={imagesArray.length > 0 ? "Update image" : "Add image"}
                tooltipOptions={{ position: 'top' }}
                onClick={(e) => this.refImageFile.click()}
                style={{ width: 'auto' }}
              />
            </div>
            <div>
              <DataTable
                value={imagesArray}
              >
                <Column
                  field="imageName"
                  header="Name"
                  body={(rowData, column) =>
                    rowData.imageId
                      ? <a href={`${Constants.apiUrl}/image/openFile/${rowData.imageId}/${rowData.imageName}`} target='_blank'>{rowData.imageName}</a>
                      : rowData.imageName
                  } />
                <Column
                  header="Actions"
                  style={{ textAlign: "center", width: "12em" }}
                  body={(rowData, column) =>
                    <div>
                      <Button
                        type="button"
                        icon="pi pi-search"
                        className="p-button-success"
                        style={{ marginRight: '.5em' }}
                        tooltip="View"
                        tooltipOptions={{ position: 'top' }}
                        onClick={(e) => this.props.toggleImageClick(e, `${Constants.apiUrl}/image/openFile/${rowData.imageId}/${rowData.imageName}`)}
                      />
                      <input
                        type="file"
                        onChange={(e) => this.handleOnChange(e)}
                        style={{ display: 'none' }}
                        ref={(el) => this.refImageFile = el}
                      />
                      <Button
                        type="button"
                        icon="pi pi-upload"
                        className="p-button-info"
                        style={{ marginRight: '.5em' }}
                        tooltip="Update"
                        tooltipOptions={{ position: 'top' }}
                        onClick={(e) => this.refImageFile.click()}
                      />
                      <Button
                        type="button"
                        icon="pi pi-times-circle"
                        className="p-button-warning"
                        tooltip="Remove"
                        tooltipOptions={{ position: 'top' }}
                        onClick={() => this.props.removeImageClick()}
                      />
                    </div>
                  }
                />
              </DataTable>
            </div>
          </div>
          <div className="p-col-12 p-md-12">
            <label>Short Description:</label>
            <InputTextarea
              name="shortDescription"
              style={{ width: '100%' }}
              onChange={(e) => this.props.handleContentChange('shortDescription', e.target['value'])}
              value={this.props.getContentValue('shortDescription')}
            />
          </div>
          <div className="p-col-12 p-md-12">
            <label>Description:</label>
            <InputTextarea
              name="description"
              style={{ width: '100%' }}
              rows={5}
              onChange={(e) => this.props.handleContentChange('description', e.target['value'])}
              value={this.props.getContentValue('description')}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default ActiveIngredientTabBasicInfo;